// jsaForm/core/signatureInfo.actions.js

export const makeJsaCoreSignatureInfoActions = ({ setJsaUi, bump, emitJsaPatch }) => ({
  updateJsaActiveSignatureTab(tab) {
    setJsaUi({
      core: (prev) => ({
        ...prev,
        signatureInfo: {
          ...(prev?.signatureInfo || {}),
          jsaActiveSignatureTab: tab,
        },
      }),
    });
    bump();
  },

  updateJsaSignatureModalOpen(open) {
    setJsaUi({
      core: (prev) => ({
        ...prev,
        signatureInfo: {
          ...(prev?.signatureInfo || {}),
          signatureModalOpen: open,
        },
      }),
    });
    bump();
  },

  updateJsaCurrentSignee(signee) {
    setJsaUi({
      core: (prev) => ({
        ...prev,
        signatureInfo: {
          ...(prev?.signatureInfo || {}),
          currentSignee: signee,
        },
      }),
    });
    bump();
  },

  updateJsaCurrentSignatureImage(image) {
    setJsaUi({
      core: (prev) => ({
        ...prev,
        signatureInfo: {
          ...(prev?.signatureInfo || {}),
          currentSignatureImage: image,
        },
      }),
    });
    bump();
  },

  addJsaSignatureEmployeeRow(jsaData, emitPatch) {
    const newRow = jsaData.addBlankJsaEmployeeSignaturesInfoRow();
    if (emitPatch && newRow) {
      const patch = newRow.toPatch({ employeeId: null }, jsaData.jsaBasicInfo.rowId, "add");
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  autoAddAllEmployeesToJsaEmployeeSignatureInfo(jsaData, employees, emitPatch) {
    const addedRows = jsaData.addAllEmployeesToJsaEmployeeSignaturesInfo(employees);
    // Emit individual patches for each added employee
    if (emitPatch && addedRows && addedRows.length > 0) {
      for (const row of addedRows) {
        const patch = row.toPatch({ employeeId: row.employeeId }, jsaData.jsaBasicInfo.rowId, "add");
        emitJsaPatch(patch, emitPatch);
      }
    }
    bump();
  },
  removeJsaSignatureEmployeeRow(jsaData, employeeRowId, emitPatch) {
    const row = jsaData.jsaEmployeeSignaturesInfo.find(r => r.rowId === employeeRowId);
    jsaData.removeJsaEmployeeSignaturesInfoRow(employeeRowId);
    if (emitPatch && row) {
      const patch = row.toPatch({}, jsaData.jsaBasicInfo.rowId, "remove");
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  selectJsaSignatureEmployee(jsaData, employee, emitPatch) {
    const row = jsaData.updateJsaSignatureSelectedEmployee(employee);
    if (emitPatch && row) {
      const patch = row.toPatch({ employeeId: employee.employeeId }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaSignatureEmployeeSignature(jsaData, signature, employeeRowId, emitPatch) {
    const row = jsaData.updateJsaSignatureEmployeeSignature(signature, employeeRowId);
    if (emitPatch && row) {
      const patch = row.toPatch({ employeeSig: signature }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  addBlankJsaNonEmployeeSignaturesInfoRow(jsaData, emitPatch) {
    const newRow = jsaData.addBlankJsaNonEmployeeSignaturesInfoRow();
    if (emitPatch && newRow) {
      const patch = newRow.toPatch({}, jsaData.jsaBasicInfo.rowId, "add");
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  removeJsaSignatureNonEmployeeRow(jsaData, nonEmployeeRowId, emitPatch) {
    const row = jsaData.jsaNonEmployeeSignaturesInfo.find(r => r.rowId === nonEmployeeRowId);
    jsaData.removeJsaNonEmployeeSignaturesInfoRow(nonEmployeeRowId);
    if (emitPatch && row) {
      const patch = row.toPatch({}, jsaData.jsaBasicInfo.rowId, "remove");
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaSignatureNonEmployeeSignature(jsaData, signature, nonEmployeeRowId, emitPatch) {
    const row = jsaData.updateJsaSignatureNonEmployeeSignature(signature, nonEmployeeRowId);
    if (emitPatch && row) {
      const patch = row.toPatch({ nonEmployeeSig: signature }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaSignatureNonEmployeeName(jsaData, name, nonEmployeeRowId, emitPatch) {
    const row = jsaData.updateJsaSignatureNonEmployeeName(name, nonEmployeeRowId);
    if (emitPatch && row) {
      const patch = row.toPatch({ nonEmployeeName: name }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaSignatureNonEmployeeCompany(jsaData, company, nonEmployeeRowId, emitPatch) {
    const row = jsaData.updateJsaSignatureNonEmployeeCompany(company, nonEmployeeRowId);
    if (emitPatch && row) {
      const patch = row.toPatch({ nonEmployeeCompany: company }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
});
